import React from 'react';

function LearningFluency() {
  return (
    <section className="learning-fluency-section">
      <div className="container">
        <h2>What is Learning Fluency?</h2>
        
        <div className="learning-fluency-content">
          <p>
            Most students are taught <strong>what</strong> to think. Few are taught <strong>how</strong> to think.
            Tests measure what you remember. Life measures what you can figure out when you don't already know
            the answer.
          </p>

          <p>
            Learning fluency is the habit of engaging with difficulty without fear, of reasoning through it,
            of treating mistakes as information rather than failure. It's the difference between knowing how to
            answer a question and knowing how to think through a new one.
          </p>

          <p>
            T.M. Theagarajan inculcated exactly this in thousands of students over five decades. They describe
            a classroom where confusion was not disdained, where reasoning mattered more than memorization,
            where they learned that struggle was not a sign of failure but a sign of growth.
          </p>

          <div className="fluency-elements">
            <h3>The Elements of Learning Fluency</h3>
            <ul>
              <li>Making mistakes safely and learning from them</li>
              <li>Comfort in engaging with unfamiliar ideas</li>
              <li>Understanding that reasoning matters more than results</li>
              <li>The capacity to separate ego from correctness</li>
              <li>Experiencing learning as joyful rather than intimidating</li>
              <li>Treating confusion as the doorway to a solution</li>
              <li>Refining thinking over time through iteration</li>
              <li>Maintaining the habit of independent learning</li>
            </ul>
          </div>

          <p>
            These are not innate talents. They are learnable habits. They can be cultivated intentionally, in
            groups, over time.
          </p>

          <p>
            That's what the TMT Learning Center is testing: whether the conditions that shaped TMT Sir's students
            can be recreated and at scale. We're not trying to find another TMT Sir. We're trying to understand
            the pattern. And if we get it right, we'll build a blueprint that others can use.
          </p>
        </div>
      </div>
    </section>
  );
}

export default LearningFluency;